// Ringkasan satu potongan waktu dari deret trail.

const R_BUMI_M = 6371000;

function haversineM(a, b) {
  const rad = (d) => (d * Math.PI) / 180;
  const dLat = rad(b[0] - a[0]);
  const dLng = rad(b[1] - a[1]);
  const s = Math.sin(dLat / 2) ** 2
    + Math.cos(rad(a[0])) * Math.cos(rad(b[0])) * Math.sin(dLng / 2) ** 2;
  return 2 * R_BUMI_M * Math.asin(Math.min(1, Math.sqrt(s)));
}

// eslint-disable-next-line import/prefer-default-export
export function segmentSummary(points, mulaiMs, selesaiMs) {
  const dalam = (points || []).filter((p) => {
    const ms = Number(p.timestamp) * 1000;
    return Number.isFinite(ms) && ms >= mulaiMs && ms <= selesaiMs;
  });
  if (dalam.length === 0) return null;
  let jarakM = 0;
  for (let i = 1; i < dalam.length; i += 1) {
    jarakM += haversineM(dalam[i - 1].latLong, dalam[i].latLong);
  }
  const durasiDetik = Number(dalam[dalam.length - 1].timestamp) - Number(dalam[0].timestamp);
  return {
    distanceM: jarakM,
    durationSec: durasiDetik,
    avgSpeedKmh: durasiDetik > 0 ? (jarakM / 1000) / (durasiDetik / 3600) : 0,
    first: dalam[0],
    last: dalam[dalam.length - 1],
  };
}
